import * as zod from 'zod';

import {
  type ModbusTCPServerReadRequest,
  ModbusTCPServerRequest,
  type ModbusTCPServerWriteRequest,
} from '@sb/integrations/implementations/ModbusTCPServer/command';
import { ModbusFunctionCodeEnum } from '@sb/integrations/utils/modbus/ModbusFunctionCode';

import { MODBUS_TCP_SERVER_REGISTER_DEFAULT } from '../constants';

export const ModbusTCPServerStepArguments = zod.object({
  kind: zod.literal('ModbusTCPServer'),
  equipmentId: zod.string(),
  registerId: zod.string(),
  request: ModbusTCPServerRequest,
});

export type ModbusTCPServerStepArguments = zod.infer<
  typeof ModbusTCPServerStepArguments
>;

export const MODBUS_TCP_READ_REGISTER_REQUEST_DEFAULT: ModbusTCPServerReadRequest =
  {
    kind: ModbusFunctionCodeEnum.ReadHoldingRegisters,
    variableIDList: [''],
    register: MODBUS_TCP_SERVER_REGISTER_DEFAULT,
  };

export const MODBUS_TCP_WRITE_REGISTER_REQUEST_DEFAULT: ModbusTCPServerWriteRequest =
  {
    kind: ModbusFunctionCodeEnum.WriteSingleRegister,
    valueList: [0],
    register: MODBUS_TCP_SERVER_REGISTER_DEFAULT,
  };

export const MODBUS_TCP_STEP_ARGS_DEFAULT: ModbusTCPServerStepArguments = {
  kind: 'ModbusTCPServer',
  equipmentId: '',
  registerId: '',
  request: MODBUS_TCP_WRITE_REGISTER_REQUEST_DEFAULT,
};
